import { useSelector } from 'react-redux';
import { EmptyState, Surface } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { useScreenResolution } from '@app/hooks';
import { selectConfig } from '@app/redux';

import { useStoreContext } from '../../context';
import { UsageToggle } from '../UsageToggle/UsageToggle';

export const ErrorState = (): JSX.Element | null => {
  const { isExtraSmall } = useScreenResolution();
  const { t } = useTranslation('Error');

  const { showMonthly } = useStoreContext();
  const initialMode = showMonthly ? 'monthly' : 'daily';
  return (
    <Surface mt="40px" mb="16px" py={isExtraSmall ? '32px' : '12px'} px={isExtraSmall ? '24px' : '32px'}>
      {
        <div style={{ display: 'flex', margin: '0px auto 48px auto' }}>
          <UsageToggle initialMode={initialMode} />
        </div>
      }
      <EmptyState title={t('title')} icon={Alert} description={t('message_graph')} />
    </Surface>
  );
};
